__turbopack_context__.v({
  "cta": "StartSimulationCard-module-scss-module__go2NwW__cta",
  "footer": "StartSimulationCard-module-scss-module__go2NwW__footer",
  "fullwidth": "StartSimulationCard-module-scss-module__go2NwW__fullwidth",
  "reviews": "StartSimulationCard-module-scss-module__go2NwW__reviews",
  "start-simulation-card": "StartSimulationCard-module-scss-module__go2NwW__start-simulation-card",
  "start-simulation-card-form": "StartSimulationCard-module-scss-module__go2NwW__start-simulation-card-form",
  "start-simulation-card-wrapper": "StartSimulationCard-module-scss-module__go2NwW__start-simulation-card-wrapper",
});
